// src/services/settings/storage.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}settings/storage/`;

export default {
  get() {
    return axios.get(API_URL, { headers: buildHeaders() });
  },

  updateDriver(driver) {
    return axios.post(
      `${API_URL}driver`,
      { driver },
      { headers: buildHeaders() }
    );
  },

  updateAws(data) {
    return axios.post(`${API_URL}aws`, data, { headers: buildHeaders() });
  },
};
